import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Desktop.css";
import { Header } from "./homeHeader";
import { HomeFooter } from "./homeFooter";
import { ErrorMessage, Field, Form, Formik } from "formik";
import api from "services/api";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import * as Yup from "yup";

import { useToaster } from "hooks";
import ShowAllPlans from "pages/home/components/showAllPlans";
import { toast } from "react-toastify";

const initialValues = {
  name: "",
  phone_no: "",
  org_name: "",
  email: "",
  subject: "",
  call_back: "",
  description: "",
  attach_file: "",
  enquiry_type: "",
  // captcha: "", // Add this line
};

const validationSchema = Yup.object({
  name: Yup.string()
    .required("Required")
    .matches(/^[a-zA-Z ]*$/, "Name can only contain letters and spaces"),
  phone_no: Yup.string()
    .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
    .required("Required"),
  org_name: Yup.string(),
  email: Yup.string().email("Invalid email format").required("Required"),
  subject: Yup.string().required("Required"),
  enquiry_type: Yup.string().required("Required"),
  description: Yup.string().required("Required"),
  call_back: Yup.string().required("Required"),
  // attach_file: Yup.mixed(),
  // captcha: Yup.string().required("CAPTCHA is required"), // Add this line
});
const Desktop = () => {
  const naivigate = useNavigate();
  const [userCaptcha, setUserCaptcha] = useState("");
  const attchRef = useRef();
  const isLoggedIn = localStorage.getItem("user");
  console.log("isLogin:", isLoggedIn);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleAttchFile = (e, setFieldValue) => {
    const file = e.target.files[0];
    const validTypes = ["image/jpeg", "image/png", "image/gif"];
    const maxSizeInBytes = 800 * 1024;

    if (file) {
      if (!validTypes.includes(file.type)) {
        toast.error("Only JPG,GIF,or PNG files are allowed");
        setFieldValue("attach_file", "");
        attchRef.current.value = null;
        return;
      }
      if (file.size > maxSizeInBytes) {
        toast.error("File size should not exceed 800KB.");
        setFieldValue("attach_file", "");
        attchRef.current.value = null;

        return;
      }

      setFieldValue("attach_file", file);
    } else {
      setFieldValue("attach_file", "");
    }
  };
  return (
    <>
      <Header />
      <div data-bs-spy="scroll" class="scrollspy-example">
        <section id="landingFeatures" className="section-py landing-features home-hero-section">
            <div className="container">
                <Link to="/register" className="d-block text-center">
                  <div
                    id="heroAnimationImg"
                    className="position-relative hero-dashboard-img"
                  >
                    <img
                      src="../../assets/img/HomePage.png"
                      alt="hero dashboard"
                      className="animation-img hero-elements-img hero-home-img"
                      data-app-light-img="front-pages/landing-page/hero-dashboard-light.png"
                      data-app-dark-img="front-pages/landing-page/hero-dashboard-dark.png"
                    />
                  </div>
                </Link>
            </div>
        </section>

        <section id="landingFeatures" className="section-py how-it-works-section">
          <div className="container container--how-it-works">
            <div className="how-it-works-header">
              <span className="how-it-works-badge">How it works</span>
              <h2 className="how-it-works-title">
                Unlock Your Zenosure Benefits in five easy steps
              </h2>
            </div>

            <div className="how-it-works-steps">
              <div className="how-it-works-step">
                <div className="how-it-works-step-inner">
                  <span className="how-it-works-step-number">1</span>
                  <div className="how-it-works-step-icon">
                    <img src="../../assets/img/front-pages/icons/user.png" alt="Register" />
                  </div>
                  <h5 className="how-it-works-step-title">Register Online</h5>
                  <p className="how-it-works-step-desc">
                    <Link to="/register" className="how-it-works-link">Sign up here</Link>
                  </p>
                </div>
              </div>
              <div className="how-it-works-step">
                <div className="how-it-works-step-inner">
                  <span className="how-it-works-step-number">2</span>
                  <div className="how-it-works-step-icon">
                    <img src="../../assets/img/front-pages/icons/chooseplan.png" alt="Choose plan" />
                  </div>
                  <h5 className="how-it-works-step-title">Choose Your Plan</h5>
                  <p className="how-it-works-step-desc">
                    Pick the perfect plan—individual or family—with benefits and savings to match. See plans{" "}
                    <Link to="/plans" className="how-it-works-link">here</Link>
                  </p>
                </div>
              </div>
              <div className="how-it-works-step">
                <div className="how-it-works-step-inner">
                  <span className="how-it-works-step-number">3</span>
                  <div className="how-it-works-step-icon">
                    <img src="../../assets/img/front-pages/icons/kyc.png" alt="KYC" />
                  </div>
                  <h5 className="how-it-works-step-title">Complete a quick KYC.</h5>
                  <p className="how-it-works-step-desc">
                    Complete a quick KYC verification to gain immediate access to services.
                  </p>
                </div>
              </div>
              <div className="how-it-works-step">
                <div className="how-it-works-step-inner">
                  <span className="how-it-works-step-number">4</span>
                  <div className="how-it-works-step-icon">
                    <img src="../../assets/img/front-pages/icons/check.png" alt="E-Card" />
                  </div>
                  <h5 className="how-it-works-step-title">Receive Zenosure E-Card</h5>
                  <p className="how-it-works-step-desc">
                    Get your Zenosure card in digital format.
                  </p>
                </div>
              </div>
              <div className="how-it-works-step">
                <div className="how-it-works-step-inner">
                  <span className="how-it-works-step-number">5</span>
                  <div className="how-it-works-step-icon">
                    <img src="../../assets/img/front-pages/icons/keyboard.png" alt="Partner locations" />
                  </div>
                  <h5 className="how-it-works-step-title">
                    Present your E-card at our Partner Locations and avail benefits
                  </h5>
                  <p className="how-it-works-step-desc">
                    Use your card at 100+ partner locations, including hospitals, pharmacies, and wellness centers, to avail of your benefits instantly.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          id="landingReviews"
          className="section-py bg-body landing-reviews pb-0"
        >
          <div
            className="d-flex row align-items-center gx-0 gy-4 g-lg-5 mb-5"
            style={{ marginLeft: "5%", width: "95%" }}
          >
            <div className="col-md-6 col-lg-5 col-xl-3 ">
              <div className="mb-3 pb-1">
                <span className="badge bg-label-primary">
                  Real Customers Reviews
                </span>
              </div>
              <h3 className="mb-1 ">
                <span className="position-relative fw-bold z-1">
                  What people say
                  <img
                    src="../../assets/img/front-pages/icons/section-title-icon.png"
                    alt="laptop charging"
                    className="section-title-img position-absolute object-fit-contain bottom-0 z-n1"
                  />
                </span>
              </h3>
              <p className="mb-3 mb-md-5">
                See what our customers have to
                <br className="d-none d-xl-block" />
                say about their experience.
              </p>
              <div className="landing-reviews-btns">
                <button
                  id="reviews-previous-btn"
                  className="btn btn-label-primary reviews-btn me-3 scaleX-n1-rtl"
                  type="button"
                  onClick={() =>
                    document
                      .getElementsByClassName("swiper-button-prev")[0]
                      ?.click()
                  }
                >
                  <i className="ti ti-chevron-left ti-sm" />
                </button>
                <button
                  id="reviews-next-btn"
                  className="btn btn-label-primary reviews-btn scaleX-n1-rtl"
                  type="button"
                  onClick={() =>
                    document
                      .getElementsByClassName("swiper-button-next")[0]
                      ?.click()
                  }
                >
                  <i className="ti ti-chevron-right ti-sm" />
                </button>
              </div>
            </div>
            <div class="col-md-6 col-lg-7 col-xl-9 ">
              <div className="container">
                <Swiper
                  modules={[Navigation, Pagination, Autoplay]} // Register modules
                  spaceBetween={50}
                  slidesPerView={1}
                  navigation
                  autoplay={{
                    delay: 3000, // 2 seconds per slide
                    disableOnInteraction: false, // Keep autoplay after manual swipe
                  }}
                  loop={true} // Enable infinite loop
                >
                  <div class="swiper-reviews-carousel overflow-hidden mb-5 pb-md-2 pb-md-3">
                    <div class="swiper " id="swiper-reviews">
                      <div class="swiper-wrapper d-flex">
                        <SwiperSlide>
                          <div class="swiper-slide ">
                            <div class="card  ">
                              <div class="card-body text-body d-flex flex-column justify-content-between h-100">
                                <p>
                                  Huge savings on my hospital bills! I was
                                  skeptical at first, but Zenosure really came
                                  through for me. I saved 15% on my hospital
                                  bill and got discounts at my local pharmacy.
                                  It’s a must-have for anyone looking to cut
                                  healthcare costs
                                </p>
                                <div class="text-warning mb-1">
                                  <i class="ti ti-star-filled ti-sm"></i>
                                  <i class="ti ti-star-filled ti-sm"></i>
                                  <i class="ti ti-star-filled ti-sm"></i>
                                  <i class="ti ti-star-filled ti-sm"></i>
                                  <i class="ti ti-star-filled ti-sm"></i>
                                </div>
                                <div class="d-flex align-items-center">
                                  <div>
                                    <h6 class="mb-0">Sandeep M.</h6>
                                    <p class="small text-muted mb-0">
                                      Bengaluru
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                        <SwiperSlide>
                          <div class="swiper-slide">
                            <div class="card h-100">
                              <div class="card-body text-body d-flex flex-column justify-content-between h-100">
                                <p>
                                  Perfect for fitness enthusiasts!" I’ve been
                                  using Zenosure for gym memberships, and the
                                  savings are incredible! I got 15% off my gym
                                  fees and even discounts on fitness gear from
                                  retail stores. It’s a great card for anyone
                                  serious about fitness
                                </p>
                                <div class="text-warning mb-1">
                                  <i class="ti ti-star-filled ti-sm"></i>
                                  <i class="ti ti-star-filled ti-sm"></i>
                                  <i class="ti ti-star-filled ti-sm"></i>
                                  <i class="ti ti-star-filled ti-sm"></i>
                                  <i class="ti ti-star-filled ti-sm"></i>
                                </div>
                                <div class="d-flex align-items-center">
                                  <div>
                                    <h6 class="mb-0">Ananya R</h6>
                                    <p class="small text-muted mb-0">Pune</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                        <SwiperSlide>
                          <div class="swiper-slide ">
                            <div class="card h-100">
                              <div class="card-body text-body d-flex flex-column justify-content-between h-100">
                                <p>
                                  Discounts on retail shopping – totally worth
                                  it!" Zenosure isn’t just for healthcare. I use
                                  it for discounts on clothes, accessories, and
                                  even groceries! I’ve saved a lot while
                                  shopping at my favorite stores. A fantastic
                                  card for both health and retail!
                                </p>
                                <div class="text-warning mb-1">
                                  <i class="ti ti-star-filled ti-sm"></i>
                                  <i class="ti ti-star-filled ti-sm"></i>
                                  <i class="ti ti-star-filled ti-sm"></i>
                                  <i class="ti ti-star-filled ti-sm"></i>
                                  <i class="ti ti-star-filled ti-sm"></i>
                                </div>
                                <div class="d-flex align-items-center">
                                  <div>
                                    <h6 class="mb-0"> Shweta P</h6>
                                    <p class="small text-muted mb-0">Jaipur</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                        <SwiperSlide>
                          <div class="swiper-slide ">
                            <div class="card h-100">
                              <div class="card-body text-body d-flex flex-column justify-content-between h-100">
                                <p>
                                  Zenosure is an absolute game-changer! It
                                  helped me save a whopping 20% on my hospital
                                  bill, which ran into lakhs.
                                </p>
                                <div class="text-warning mb-1">
                                  <i class="ti ti-star-filled ti-sm"></i>
                                  <i class="ti ti-star-filled ti-sm"></i>
                                  <i class="ti ti-star-filled ti-sm"></i>
                                  <i class="ti ti-star-filled ti-sm"></i>
                                  <i class="ti ti-star-filled ti-sm"></i>
                                </div>
                                <div class="d-flex align-items-center">
                                  <div>
                                    <h6 class="mb-0">Dipika</h6>
                                    <p class="small text-muted mb-0">Mysore</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      </div>
                      <div class="swiper-button-next"></div>
                      <div class="swiper-button-prev"></div>
                    </div>
                  </div>
                </Swiper>
              </div>
            </div>
          </div>

          <hr className="m-0" />
        </section>

        <section id="landingFunFacts" className="section-py landing-fun-facts">
          <div className="container">
            <div className="row gy-2 row-equal-height">
              <div className="col-sm-6 col-lg-3 d-flex">
                <div className="card border border-label-primary shadow-none w-100">
                  <div className="card-body text-center d-flex flex-column">
                    <div className="icon-wrapper mb-3">
                      <img
                        src="../../assets/img/front-pages/icons/laptop.png"
                        alt="laptop"
                        className="card-icon"
                        style={{
                          width: "48px",
                          height: "48px",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <h5>100+</h5>
                    <p
                      className="fw-medium mb-0 flex-grow-1"
                      style={{
                        fontSize: "0.875rem",
                        lineHeight: "1.4",
                        color: "#697a8d",
                      }}
                    >
                      Network of hospitals,gyms,
                      <br />
                      pharmacies and wellness centres
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-lg-3 d-flex">
                <div className="card border border-label-success shadow-none w-100">
                  <div className="card-body text-center d-flex flex-column">
                    <div className="icon-wrapper mb-3">
                      <img
                        src="../../assets/img/front-pages/icons/user-success.png"
                        alt="user success"
                        className="card-icon"
                        style={{
                          width: "48px",
                          height: "48px",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <h5>8 lakh+</h5>
                    <p
                      className="fw-medium mb-0 flex-grow-1"
                      style={{
                        fontSize: "0.875rem",
                        lineHeight: "1.4",
                        color: "#697a8d",
                      }}
                    >
                      Members
                      <br />
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-lg-3 d-flex">
                <div className="card border border-label-info shadow-none w-100">
                  <div className="card-body text-center d-flex flex-column">
                    <div className="icon-wrapper mb-3">
                      <img
                        src="../../assets/img/front-pages/icons/diamond-info.png"
                        alt="diamond info"
                        className="card-icon"
                        style={{
                          width: "48px",
                          height: "48px",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <h5>4.8/5</h5>
                    <p
                      className="fw-medium mb-0 flex-grow-1"
                      style={{
                        fontSize: "0.875rem",
                        lineHeight: "1.4",
                        color: "#697a8d",
                      }}
                    >
                      Highly rated
                      <br />
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-lg-3 d-flex">
                <div className="card border border-label-warning shadow-none w-100">
                  <div className="card-body text-center d-flex flex-column">
                    <div className="icon-wrapper mb-3">
                      <img
                        src="../../assets/img/front-pages/icons/check-warning.png"
                        alt="check warning"
                        className="card-icon"
                        style={{
                          width: "48px",
                          height: "48px",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <h5>Save Upto 50%</h5>
                    <p
                      className="fw-medium mb-0 flex-grow-1"
                      style={{
                        fontSize: "0.875rem",
                        lineHeight: "1.4",
                        color: "#697a8d",
                      }}
                    >
                      Cashback or Discounts
                      <br />
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="landingFAQ" className=" bg-body landing-faq">
          <div className="container">
            <div className="text-center mb-3 pb-1">
              <span
                className="badge bg-label-primary mt-3"
                style={{ padding: "0.6rem 1.2rem", fontSize: "1rem" }}
              >
                FAQ
              </span>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-7 ">
                <div className="accordion" id="accordionExample">
                  <div className="card accordion-item active">
                    <h2 className="accordion-header" id="headingOnew">
                      <button
                        type="button"
                        className="accordion-button"
                        data-bs-toggle="collapse"
                        data-bs-target="#accordionOnew"
                        aria-expanded="true"
                        aria-controls="accordionOnew"
                      >
                        What is the Zenosure E-card and how does it work?
                      </button>
                    </h2>
                    <div
                      id="accordionOnew"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div
                        className="accordion-body"
                        style={{ textAlign: "justify" }}
                      >
                        When you sign up for a Zenosure yearly plan, you’ll
                        receive a digital E-card sent to your registered mobile
                        number and email. Simply show this E-card at any of our
                        partner locations—hospitals, pharmacies, diagnostic
                        labs, wellness centers, spas, and more—to access
                        exclusive benefits and discounts.
                        <br />
                        <br />
                        <strong>Please note:</strong> Benefits vary by partner
                        and may change from time to time. The discounts or
                        offers you receive will depend on the partner’s current
                        terms at the time of your visit.
                      </div>
                    </div>
                  </div>
                  <div className="card accordion-item ">
                    <h2 className="accordion-header" id="headingOne">
                      <button
                        type="button"
                        className="accordion-button"
                        data-bs-toggle="collapse"
                        data-bs-target="#accordionOne"
                        aria-expanded="true"
                        aria-controls="accordionOne"
                      >
                        Is Zenosure the same as health insurance?
                      </button>
                    </h2>
                    <div
                      id="accordionOne"
                      className="accordion-collapse collapse "
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>No. Zenosure is not an insurance. It is a smart health and
                        wellness membership that gives you instant access to
                        discounts, cashback, and special offers at our partner
                        hospitals, labs, pharmacies and wellness centers.</p>

                        You will receive these benefits whether or not you
                        have an insurance.
                      </div>
                    </div>
                  </div>
                  <div className="card accordion-item">
                    <h2 className="accordion-header" id="headingTwo">
                      <button
                        type="button"
                        className="accordion-button"
                        data-bs-toggle="collapse"
                        data-bs-target="#accordionTwo"
                        aria-expanded="true"
                        aria-controls="accordionTwo"
                      >
                        Do I need to have insurance to use Zenosure?
                      </button>
                    </h2>
                    <div
                      id="accordionTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        No. You do not need any insurance to access Zenosure
                        benefits. Anyone can join and start availing the benefits immediately.
                      </div>
                    </div>
                  </div>
                  <div className="card accordion-item">
                    <h2 className="accordion-header" id="headingThree">
                      <button
                        type="button"
                        className="accordion-button"
                        data-bs-toggle="collapse"
                        data-bs-target="#accordionThree"
                        aria-expanded="true"
                        aria-controls="accordionThree"
                      >
                        Can I use Zenosure even if I already have health
                        insurance?
                      </button>
                    </h2>
                    <div
                      id="accordionThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Absolutely. Zenosure works independently of your
                        insurance. You can use your E-card and enjoy the
                        benefits regardless of whether you have
                        insurance or not.
                      </div>
                    </div>
                  </div>
                  <div className="card accordion-item">
                    <h2 className="accordion-header" id="headingFour">
                      <button
                        type="button"
                        className="accordion-button"
                        data-bs-toggle="collapse"
                        data-bs-target="#accordionFour"
                        aria-expanded="true"
                        aria-controls="accordionFour"
                      >
                        How long does it take for my Zenosure plan to get
                        activated?
                      </button>
                    </h2>
                    <div
                      id="accordionFour"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingFour"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Once you register and buy a plan, submit your KYC documents. We'll verify your information within 48 hours and send your digital E-card to your email and phone.
                        You can start using your benefits right away.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <br />
        <HomeFooter />
      </div>
    </>
  );
};

export default Desktop;
